import { render, staticRenderFns } from "./CampanhaModal.vue?vue&type=template&id=2e6c320a&scoped=true"
import script from "./CampanhaModal.vue?vue&type=script&lang=js"
export * from "./CampanhaModal.vue?vue&type=script&lang=js"
import style0 from "./CampanhaModal.vue?vue&type=style&index=0&id=2e6c320a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c320a",
  null
  
)

export default component.exports